// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Mhs6","col":"styles_col__2TACA","fulfillmentStatus":"styles_fulfillmentStatus__Rr3e9","emailCol":"styles_emailCol__1gsm2"};